// lessons/les1-motiverende-gespreksvoering/modules/Module3.js
export const MODULE3_CONFIG = {
    id: 'module3',
    title: 'Vragen Stellen: Nodig uit tot Verandertaal',
    type: 'conversation',
    duration: 65,
    
    theory: {
      title: 'Vragen stellen: nodig uit tot verandertaal',
      sections: [
             {
          id: 'verandertaal ontlokken met open vragen',
          title: 'Verandertaal Ontlokken',
          content: `In de vorige module heb je geoefend met het verdiepen van het gesprek, zonder daarbij een specifieke richting te geven. Deze manier van vragen stellen is helpend bij het verkennen van ambivalentie en het opbouwen van een vertrouwensband met de cliënt.

Je kunt het gesprek echter ook bewust een richting geven door specifieke vragen te stellen die de cliënt uitnodigen om verandertaal te verwoorden. In motiverende gespreksvoering wordt dit het 'ontlokken' van verandertaal genoemd..
`
        },
        {
          id: 'verandertaal-vragen',
          title: 'Vragen naar vier soorten verandertaal',
          content: `Open vragen kunnen cliënten uitnodigen om hun eigen motivatie onder woorden te brengen. Zoals je weet noemen we dit 'verandertaal'. Verandertaal is nog een breed begrip, dit wordt vaak nog onderverdeeld in vier of vijf categorieën. Wij kiezen voor vier categorieën om het overzichtelijk te houden:
          
          1. Wensen – wat iemand graag anders zou willen

          2. Mogelijkheden – hoe het kan en of het lukt

          3. Redenen – waarom iemand dat zou willen

          4. Noodzaak – waarom het echt nodig is

         


Door open vragen te stellen die aansluiten bij deze vormen, help je de cliënt om specifieke soorten verandertaal te verwoorden.

**Wensen of verlangens**

Vragen naar wensen of verlangens helpen de cliënt om stil te staan bij wat hij of zij graag zou willen bereiken. Deze vragen nodigen uit om te dromen en een gewenst toekomstbeeld te schetsen. Ze zijn vooral helpend aan het begin van een gesprek, wanneer iemand nog zoekend is of ambivalent staat tegenover verandering.

Door te praten over wat iemand wil, verschuift de aandacht van problemen naar mogelijkheden. Dit kan een positieve draai geven aan het gesprek.

Voorbeelden: 

"Wat zou u het liefst willen?"

"Wat hoopt u te bereiken?"

**Vermogen**

Vragen naar vermogen richten zich op wat iemand denkt te kunnen doen en welke krachten, vaardigheden of eerdere successen daarbij een rol spelen. Deze vragen versterken het gevoel van zelfvertrouwen en eigen regie. Ze maken zichtbaar dat verandering niet alleen wenselijk is, maar ook haalbaar kan zijn.

Dit type vragen is  waardevol wanneer iemand twijfelt aan zichzelf of geneigd is te benadrukken wat niet lukt.

Voorbeelden:

"Wat denkt u dat mogelijk is?"

"Wat zou u zelf kunnen doen?"

**Redenen**

Vragen naar redenen helpen de cliënt te verwoorden waarom een verandering voor hem of haar belangrijk is. Ze nodigen uit om persoonlijke waarden, voordelen en motieven te benoemen. Hoe vaker iemand zijn eigen redenen uitspreekt, hoe sterker de motivatie kan worden.

Deze vragen werken goed wanneer iemand wel openstaat voor verandering, maar nog niet helder heeft wat het hem of haar concreet oplevert.

Voorbeelden: 

"Waarom zou u dit willen veranderen?" 

"Wat zou het u opleveren?"

**Noodzaak**

Vragen naar noodzaak gaan over de urgentie van verandering: hoe belangrijk of dringend voelt het voor de cliënt om nu iets te doen? Ze helpen om het verschil zichtbaar te maken tussen de huidige situatie en wat iemand eigenlijk wil.

Dit type vragen vraagt om zorgvuldigheid. Ze werken het best wanneer er al enige bereidheid is om te veranderen.

Voorbeelden:

"Hoe belangrijk is deze verandering voor u?"

"Wat maakt dat u deze verandering niet langer uit wil stellen?"

Om verandertaal uit te lokken, is het belangrijk dat je de vier typen verandertaal en de bijbehorende vraagvormen goed paraat hebt. In een echt gesprek is er vaak weinig tijd om na te denken over welke vraag je precies gaat stellen. Wanneer je de verschillende vormen van verandertaal kent en de bijpassende vragen in je gereedschapskist hebt, kun je in het moment flexibel inspelen op wat de cliënt zegt. Dit ga je straks in het simulatiegesprek oefenen.`
        },

        {
          id: 'bronnen',
          title: 'Aanbevolen bronnen',
          content: `Wil je meer weten over verandertaal ontlokken met open vragen? Bekijk dan onderstaande bron!
          
          Verandertaal ontlokken met open vragen
https://youtu.be/kOHcxktQfL4?si=6PnOvA2TbQtSNUZL
In de video wordt met voorbeelden uit de mondzorg uitgelegd welke open vragen effectief leiden tot verandertaal.
Kijktijd: 4 minuten
`
        },
        
        {
          id: 'introductie opdracht',
          title: 'Introductie Opdracht',
          content: `**Uitleg**
          
      In de volgende simulatiegesprekken ga je oefenen met het ontlokken van de vier soorten verandertaal: wensen, vermogen, redenen en noodzaak. Je bent geslaagd wanneer je vragen hebt gesteld die aansluiten bij alle vier deze vormen van verandertaal.

Je spreekt eerst Sanne, die je al kent uit de vorige module. Daarna ga je in gesprek met Bram, waarbij jij de rol van zijn logopedist hebt.      

**Tips**

Als je tijdens het gesprek de theorie wilt raadplegen, bijvoorbeeld om te bekijken welke soorten verandertaal er zijn en welke vragen daarbij passen, kun je rechtsboven in het gespreksvenster op de knop ‘Theorie’ klikken. De theorie opent dan in een nieuw tabblad.

Het kan wat kunstmatig aanvoelen om alle categorieën van verandertaal bewust langs te gaan. Probeer ze toch allemaal uit en observeer hoe de cliënt reageert.
          `
        }
      ]
    },
  
    conversations: {
      total: 2,
      passingCriteria: 'In een gesimuleerd gesprek open vragen stellen naar alle vier de categorieën verandertaal: wensen, redenen, noodzaak en vermogen om te veranderen.',
      
      instruction: `Ga een natuurlijk gesprek aan met de cliënt, en stel open vragen om verandertaal te ontlokken. Je behaalt de oefening als je vragen hebt gesteld die de cliënt uitnodigen te praten over vier soorten verandertaal: Wensen, vermogen, redenen en noodzaak om te veranderen. Heb je naar de vier soorten verandertaal gevraagd? Klik dan op 'Evalueer gesprek' om feedback te krijgen op je gesprekstechniek en na te gaan of je de opdracht hebt behaald.`,


      afterConversation1: `Goed gedaan! Je hebt naar vier soorten verandertaal gevraagd. Lees nu onderstaande feedback op jouw gesprekstechnieken, en probeer nog effectiever vragen te stellen in de tweede ronde!

Tip: schrijf op welke feedback jij nuttig vindt om mee te nemen in het volgende simulatiegesprek!`,

      afterConversation2: `Goed gedaan! Je hebt naar vier soorten verandertaal gevraagd. Je hebt dus het leerdoel van deze module behaald. Lees de onderstaande feedback en ga vervolgens verder met de volgende module over het formuleren van reflecties.

Tip: schrijf op welke feedback jij nuttig vindt om toe te passen in jouw praktijk als behandelaar!`
    },
  
    completionCriteria: {
      type: 'conversation_evaluation',

      requiredConversations: 2,
      requiredChangeTypes: 4, // Must cover all four change talk categories
      description: 'Beide gesprekken succesvol afgerond met vragen naar alle vier categorieën verandertaal'
    }
  };
  
  export default MODULE3_CONFIG;